import React from "react";

function Footer() {
    return (
        <footer>
            <p>&#169; 2020 Matthew Weston</p>
        </footer>
    )
}
export default Footer;